import { Component, OnInit, Input } from '@angular/core';
import { CourseViewModel, CourseEventStatus, CourseViewModelSimple } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Enums } from 'src/app/_models/generatedEnums';
import { Router } from "@angular/router";
import { NavigationService } from "../../_services/navigation-service";
import { SettingsProvider } from "../../_services/settingsProvider.service";

@Component({
  selector: 'bxl-course-item',
  styles: [':host { display: contents; }'],
  templateUrl: 'course-item.component.html'
})
export class CourseItemComponent implements OnInit {
  initialized = false;
  @Input() course: CourseViewModelSimple;
  @Input() displayPrice = true;
  @Input() displayArchiveDate = false;
  @Input() isGrid = false;
  @Input() rootRoute: string = "/";
  modifiedCourseExpirationDate: Date | null = null;

  CourseEventStatus = CourseEventStatus;
  CourseEventStatusEnum = Enums.CourseEventStatusEnum;
  Math = Math;

  constructor(public auth: AuthenticationService, public settings: SettingsProvider, private router: Router, private navService: NavigationService) {}

  ngOnInit(): void {
    if (this.course.archiveDate) {
      this.modifiedCourseExpirationDate = new Date(this.course.archiveDate);
      this.modifiedCourseExpirationDate.setDate(this.modifiedCourseExpirationDate.getDate() - 1);
    }
    this.initialized = true;
  }

  public subscribe() {
    if (this.auth.isLoggedIn()) {
      this.router.navigate(['/account/subscription']);
    } else {
      this.navService.showLogin().then(() => this.router.navigate(['/account/subscription']));
    }
  }
}
